module.exports = __webpack_public_path__ + "static/media/reanimationlabsbannerWAlt.81f2adc5.svg";